<template>
    <div>
        <div>
            <div class="top-logo-bar" style="display: flex; align-items: center;" >
                <router-link :to="{name: 'login'}" style="align-items: left; display: flex">
                    <img class="app-logo" src="~@/assets/img/Menu/Logo.svg" style="margin-left:10vw ; height:35px; margin-top:0px; padding-right: 20px; border-right: 1px solid #AEAEAE7F"/>
                    <img class="app-logo" src="~@/assets/img/Menu/TransparencyLogo.svg" style="margin-left:20px;height:35px;margin-top:0px;"/>
                </router-link>
            </div>
        </div>
        <div class="policy-container">
            <div class="main-header">GDPR Privacy Policy of BioControl</div>
            <div style="padding-bottom: 30px;">
                <div>
                    <p style="margin: unset; font-weight: 600">Last updated: Apr 26, 2021</p>
                </div>
                <section>
                    <div class="section-header">Definitions</div>
                    <p><b>BioControl</b><br/>BioControl means BioControl AS, BioControl Polska, BioControl North America with its principal place of business at 75 Gautestadveien, 1890 Rakkestad, Norway.</p>
                    <p><b>GDPR</b><br/>General Data Protection Regulation Act.</p>
                    <p><b>Data Controller</b><br/>Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.</p>
                    <p><b>Data Processor</b><br/>Data Processor means any natural or legal person who processes the data on behalf of the Data Controller.</p>
                    <p><b>Data Subject</b><br/>Data Subject is any living individual who is using our Service and is the subject of Personal Data.</p>
                </section>
                <section>
                    <div class="section-header">1. Principles for processing personal data</div>
                    <p>Our principles for processing personal data are:</p>
                    <p><b>Fairness and lawfulness.</b> When we process personal data, the individual rights of the Data Subjects must be protected. All personal data must be collected and processed in a legal and fair manner.</p>
                    <p><b>Restricted to a specific purpose.</b> The personal data of Data Subject must be processed only for specific purposes.</p>
                    <p><b>Transparency.</b> The Data Subject must be informed of how his/her data is being collected, processed and used.</p>
                </section>
                <section>
                    <div class="section-header">2. What personal and system data we collect and process</div>
                    <p>BioControl collects several different types of personal data for various purposes. Personal Data may include, but is not limited to:</p>
                    <ul>
                        <li>Email address</li>
                        <li>Account password</li>
                        <li>First name and last name</li>
                        <li>Phone number</li>
                        <li>Address, State, Province, ZIP/Postal code, City</li>
                    </ul>
                    <p>What is more, BioControl collects several different types of system data for various purposes (e.g. system diagnostics). System Data may include, but is not limited to:</p>
                    <ul>
                        <li>System location</li>
                        <li>IP Address</li>
                        <li>Software, firmware version</li>
                        <li>Alarms in the system</li>
                        <li>Current system status</li>
                    </ul>
                    <p>Please note, BioControl will never collect and store your logs/visits data (consumption logs, visit logs) unless prior consent from system owner. What is more, BioControl will not forward/sell any information to other parties. </p>
                </section>
                <section>
                    <div class="section-header">3. How we use the personal and system data</div>
                    <p>BioControl uses the collected personal and system data for various purposes:</p>
                    <ul>
                        <li>To provide you with services</li>
                        <li>To notify you about changes to our services and/or products</li>
                        <li>To provide customer support</li>
                        <li>To gather analysis or valuable information so that we can improve our services</li>
                        <li>To detect, prevent and address technical issues</li>
                    </ul>
                </section>
                <section>
                    <div class="section-header">4. Legal basis for collecting and processing personal data</div>
                    <p>BioControl legal basis for collecting and using the personal data described in this Data Protection Policy depends on the personal data we collect and the specific context in which we collect the information:</p>
                    <ul>
                        <li>BioControl needs to perform a contract with you</li>
                        <li>You have given BioControl permission to do so</li>
                        <li>Processing your personal data is in BioControl legitimate interests</li>
                        <li>BioControl needs to comply with the law</li>
                    </ul>
                </section>
                <section>
                    <div class="section-header">5. Retention of personal data</div>
                    <p>BioControl will retain your personal information only for as long as is necessary for the purposes set out in this Data Protection Policy.</p>
                    <p>BioControl will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.</p>
                </section>
                <section>
                    <div class="section-header">6. Data transfers</div>
                    <p>BioControl may transfer to, and store the data we collect about you and system in, countries other than the country in which the data was originally collected, including the United States, Canada or other destinations outside the European Economic Area (“EEA”). Those countries may not have the same data protection laws as the country in which you provided the data. When we transfer your data to other countries, we will protect the data as described in this Privacy Policy and comply with applicable legal requirements providing adequate protection for the transfer of data to countries outside the EEA.</p>
                    <p>If you are located in the EEA, we will only transfer your personal and system data if:</p>
                    <ul>
                        <li>The country to which the personal data will be transferred has been granted a European Commission adequacy decision;</li>
                        <li>The recipient of the personal data is located in the US and has certified to the US-EU Privacy Shield Framework; or</li>
                        <li>BioControl have put in place appropriate safeguards in respect of the transfer</li>
                    </ul>
                </section>
                <section>
                    <div class="section-header">7. Data protection rights</div>
                    <p>If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what personal data BioControl holds about you and if you want it to be removed from our systems, please contact us.</p>
                    <p>In certain circumstances, you have the following data protection rights:</p>
                    <ul>
                        <li>The right to access, update or to delete the information we have on you</li>
                        <li>The right of rectification</li>
                        <li>The right to object</li>
                        <li>The right of restriction</li>
                        <li>The right to data portability</li>
                        <li>The right to withdraw consent</li>
                    </ul>
                </section>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.top-logo-bar {
    width: 100%;
    height: 100px;
    background: #347C93;
}

.section-header {
    margin-bottom: 20px;
    margin-top: 40px;
    font-weight: 600;
    font-size: 24px;
}

.main-header {
    font-weight: 700;
    font-size: 32px;
    margin-top: 20px;
}

section {
    padding-right: 40vw;
}

p {
    text-align: justify;
    /* margin-left: 2vw; */
}

li {
    font-weight: 700;
}

.policy-container {
    height: calc(100% - 100px); 
    overflow-y: scroll; 
    padding-left: calc(15vw + 30px);
}

@media only screen and (max-width: 700px) {
    .policy-container {
        padding-left: 5%;
    }

    section {
        padding-right: 5%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Policy.vue